import React from "react";

const ProcediButton = ({ handleClickCallback }) => {
  return (
    <div className="flex flex-row gap-x-2">
      <button
        className="border-2 border-orange-400 p-2 rounded-md px-8 uppercase text-orange-400 hover:bg-orange-400 hover:text-white duration-300"
        onClick={() => {
          handleClickCallback();
        }}
      >
        Procedi
      </button>
    </div>
  );
};

export default ProcediButton;
